import React from "react";
import "../ProductCardsModems.css";
import { Link } from "react-router-dom"; 
import '../../i18n';
import { useTranslation } from 'react-i18next';

import ImageSpin12 from "../../assets/images/modems/processed/spin_12_usbl.png"

const Spin12_USBL = () => {
  const { t, i18n } = useTranslation();
  
  return (
    <Link to="/usbl-product#spin12_usbl_spec" className="card-link-wrapper"> {/* Wrap card with Link */}
          <div className="card">
            <img src={ImageSpin12} alt={t('products.types.communcation_12_USBL.title')} className="card-image" />
            <div className="card-content">
              <h3 className="card-title">{t('products.types.communcation_12_USBL.title')}</h3>
              <p className="card-description">
                <ul class="features-list">
                  <li>{t('products.types.communcation_12_USBL.li_1')}</li>
                  <li>{t('products.types.communcation_12_USBL.li_2')}</li>
                  <li>{t('products.types.communcation_12_USBL.li_3')}</li>
                  <li>{t('products.types.communcation_12_USBL.li_4')}</li>
                </ul>
              </p>
            </div>
          </div>
      </Link>
  );
};
export default Spin12_USBL;